import React, { ReactElement } from "react";
import FeedbackType from "../../FeedbackType";
import colors from "../../style/colors";

interface Props {
  replacement: string;
  onClick?: (suggestion: string) => void;
  type: FeedbackType;
}

const TYPE_TO_BG_COLOR = {
  grammar: "hover:bg-grammar-blue-500",
  style: "hover:bg-style-green-500",
  spelling: "hover:bg-spelling-red-500",
};

function CardReplacement({
  replacement: suggestion,
  type,
  onClick,
}: Props): ReactElement {
  const { text } = colors.actionable[type];
  const hoverBgColor = TYPE_TO_BG_COLOR[type];
  return (
    <button
      className={`${text} pl-3.5 py-1.5 text-left font-bold text-sm hover:text-white ${hoverBgColor}`}
      onClick={() => onClick?.(suggestion)}
      type="button"
    >
      {suggestion}
    </button>
  );
}

export default CardReplacement;
